import { Code2 } from 'lucide-react';

interface AgentCodeWriteBadgeProps {
    hasCodeWriteAccess: boolean;
}

export function AgentCodeWriteBadge({
    hasCodeWriteAccess
}: AgentCodeWriteBadgeProps) {
    if (!hasCodeWriteAccess) return null;

    return (
        <div className="flex items-center gap-1.5 bg-violet-50 dark:bg-violet-950/40 p-1.5 pr-3 pl-2 border border-rounded border-violet-100 dark:border-violet-900 rounded-full w-fit font-medium text-xs">
            <Code2 strokeWidth={1.5} className="size-4! text-violet-950 dark:text-violet-200" />
            <span className="text-violet-950/80 dark:text-violet-200/80">Code write access</span>
        </div>
    );
}
